var _g, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcBarcodeScanned(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9434 20.7784C10.9434 21.3157 11.3794 21.7518 11.9166 21.7518C12.4539 21.7518 12.8899 21.3157 12.8899 20.7784V4.71943C12.8899 4.18215 12.4539 3.74609 11.9166 3.74609C11.3794 3.74609 10.9434 4.18215 10.9434 4.71943V20.7784Z",
    fill: "#009B62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0508 12.2842C19.0508 12.8214 19.4868 13.2575 20.0241 13.2575C20.5613 13.2575 20.9973 12.8214 20.9973 12.2842V4.71943C20.9973 4.18215 20.5613 3.74609 20.0241 3.74609C19.4868 3.74609 19.0508 4.18215 19.0508 4.71943V12.2842Z",
    fill: "#009B62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.99805 20.7317C2.99805 21.269 3.43408 21.705 3.97133 21.705C4.50858 21.705 4.94461 21.269 4.94461 20.7317V4.7204C4.94461 4.18312 4.50858 3.74707 3.97133 3.74707C3.43408 3.74707 2.99805 4.18312 2.99805 4.7204V20.7317Z",
    fill: "#009B62"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0781 14.8625C15.5261 14.8625 15.0781 14.4145 15.0781 13.8625V4.50049C15.0781 3.94849 15.5261 3.50049 16.0781 3.50049C16.6301 3.50049 17.0781 3.94849 17.0781 4.50049V13.8625C17.0781 14.4145 16.6301 14.8625 16.0781 14.8625Z",
    fill: "#009B62"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 20.9505C6.75 21.5025 7.198 21.9505 7.75 21.9505C8.302 21.9505 8.75 21.5025 8.75 20.9505V4.50049C8.75 3.94849 8.302 3.50049 7.75 3.50049C7.198 3.50049 6.75 3.94849 6.75 4.50049V20.9505Z",
    fill: "#009B62"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9944 20.0295C17.1894 20.2245 17.4454 20.3225 17.7014 20.3225C17.9574 20.3225 18.2134 20.2245 18.4084 20.0295L22.2624 16.1765C22.6534 15.7865 22.6534 15.1535 22.2624 14.7625C21.8714 14.3715 21.2394 14.3715 20.8484 14.7625L17.7014 17.9085L16.8674 17.0745C16.4764 16.6835 15.8444 16.6835 15.4534 17.0745C15.0624 17.4655 15.0624 18.0975 15.4534 18.4885L16.9944 20.0295Z",
    fill: "#009B62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBarcodeScanned);
export default __webpack_public_path__ + "static/media/ic_barcode_scanned.ee724bea72c762382482f1c5a811d046.svg";
export { ForwardRef as ReactComponent };